import React from 'react';
import { Button } from '@material-ui/core';

const SubscribeButton = ({
  subscriptionStatus,
  isPlayerInRole = false,
  onSubscribe,
  onCancelRequest,
  onUnsubscribe,
  label,
  className = '',
}) => {
  const handleClick = () => {
    console.log('SubscribeButton clicked:', subscriptionStatus);
    if (subscriptionStatus === 'Subscribe') {
      onSubscribe && onSubscribe();
    } else if (subscriptionStatus === 'Requested') {
      onCancelRequest && onCancelRequest();
    } else if (subscriptionStatus === 'Subscribed') {
      onUnsubscribe && onUnsubscribe();
    }
  };

  let buttonText = subscriptionStatus;
  if (subscriptionStatus === 'Requested') buttonText = 'Cancel Request';
  if (label) buttonText = label;

  return (
    <Button
      variant="contained"
      className={className}
      onClick={handleClick}
      disabled={isPlayerInRole}
    >
      {buttonText}
    </Button>
  );
};

export default SubscribeButton;
